import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../../../library-js/dom-tools/HTMLEditor";

export class MobileKeyboardElement
{
  static readonly type = new ElementType( "mobile-keyboard-ui" );

  static applyOnDocument()
  { 
    MobileKeyboardElement.type.forAllInDoc( e => MobileKeyboardElement.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let input = new ElementType( "mobile-input" ).query( e );

    let pages = [ "lower-case" ];

    let layout:string[] = 
    [ 
      "!\"\'\`+-/*=?←",
      "1234567890↵",
      "qwertzuiopü",
      "asdfghjklöä",
      "yxcvbnm.,;:",      
      "<{[( )]}>"
      
    ];

    let mobileKeyboardElement = new ElementType( "mobile-keyboard" ).query( e );

    pages.forEach(
      ( p )=>
      {
        let layoutCopy = [].concat( layout );

        let keyboardPage = new ElementType( "keyboard-page" ).create();

        let rowIndex = 0;
        layoutCopy.forEach(
          ( row:string )=>
          {
            let keyboardRow = new ElementType( "keyboard-row" ).create();

            for ( let i = 0; i < row.length; i++ )
            {
              let text = row[ i ];

              let isSpace = text === " ";

              if ( isSpace )
              {
                text = "_____";
              }
             

              let button = ElementType.button.create( text );

              if ( isSpace )
              {
                button.style.width = "4.5em";
                // button.style.color = "hsl(0,0%,0%,0.2)";
              }

              if ( text === "←" || text == "↵")
              {
                button.style.width = "2.4em";
              }
              keyboardRow.appendChild( button );
            }

            keyboardPage.appendChild( keyboardRow );
            rowIndex ++;
          }
        )

        mobileKeyboardElement.appendChild( keyboardPage );

        
    
      }
    )
    
    ElementType.button.forAll( e, 
      ( btn )=>
      {
        OnClick.add( btn, 
          ()=>
          {
            let text = input.textContent;
            let inputContent = btn.textContent;

            if ( inputContent === "_____")
            { 
              inputContent = " ";
            }

            if ( inputContent === "↵" )
            {
              inputContent = "\n";
            }

            if ( inputContent === "←" )
            {
              HTMLEditor.setText( input, text.substring( 0, text.length - 1 ) );
            }
            else
            {
              HTMLEditor.setText( input, text + inputContent );
            }

            
          }
        );

      }
    );
  }
}